import { forwardRef } from 'react';

import { Error } from '../../Form.styles';
import { Label } from '../Label/Label';
import { Info, Input } from './InputField.styles';
import type { InputFieldProps } from './InputField.types';

export const InputField = forwardRef<HTMLDivElement, InputFieldProps>(
  (
    {
      htmlId,
      label,
      type,
      inputMode,
      placeholder,
      autoFocus,
      info,
      error,
      ...inputRest
    },
    ref
  ) => {
    return (
      <div ref={ref}>
        <Label htmlId={htmlId} label={label} />

        <Input
          id={htmlId}
          autoFocus={autoFocus}
          type={type ?? 'text'}
          inputMode={inputMode ?? 'text'}
          placeholder={placeholder}
          aria-invalid={!!error}
          {...inputRest}
        />

        {!!info?.length && <Info>{info}</Info>}

        {!!error && typeof error === 'string' && <Error>{error}</Error>}
      </div>
    );
  }
);

InputField.displayName = 'InputField';
